import {
  closeTransitionMenuMobile,
  closeTransitionSearch,
  closeTransitionSubMenuPc,
} from './toggle'

export const delayTransition = (second) => {
  let sec = second
  sec = second || 1000
  return new Promise((done) => {
    setTimeout(() => {
      done()
    }, sec)
  })
}

export const initTransitionMobile = () => {
  closeTransitionSearch()
  closeTransitionMenuMobile()
}

export const initTransitionPc = () => {
  closeTransitionSubMenuPc()
}

export const beforeAnimateTransition = () => {}

export const afterAnimateTransition = () => {}
